import * as React from 'react';
import { CountBadge } from '../../../../web/components-v2/CountBadge';
import { AppDrawerToolbarButton, useAppDrawerContext } from '../../../../web/components-v2/Drawer/AppDrawer';
import { SparklesIcon } from '../../../../web/components/svgs/icons/SparklesIcon';
import { TYSON_COACHING_DRAWER_VALUE } from '../../../components/Queue';
import { useTysonCoaching } from '../../contexts/TysonCoachingContext';
import { useUnreadAssistantCount } from '../../hooks/useUnreadAssistantCount';

interface TysonCoachingDropdownProps {
	disabled?: boolean;
}

export const TysonCoachingDropdown: React.FC<TysonCoachingDropdownProps> = ({ disabled }) => {
	const { coachingMessages } = useTysonCoaching();
	const { value } = useAppDrawerContext();
	const unreadCount = useUnreadAssistantCount(coachingMessages, value === TYSON_COACHING_DRAWER_VALUE);

	return (
		<AppDrawerToolbarButton value={TYSON_COACHING_DRAWER_VALUE} tooltip='AI Coaching' disabled={disabled}>
			<SparklesIcon />
			<CountBadge count={unreadCount} aria-label={`${unreadCount} unread`} />
		</AppDrawerToolbarButton>
	);
};
